import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        const userDoc = await getDoc(doc(db, "users", currentUser.email));
        const data = userDoc.exists() ? userDoc.data() || {} : {};

        setRole(data.role || null);
        setUserPermissions({
          aractakip: data.aractakip || data["arac-takip"] || {},
          "arac-takip": data["arac-takip"] || data.aractakip || {},
        });
      } else {
        setUser(null);
        setRole(null);
        setUserPermissions({});
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = () => signOut(auth);

  return (
    <AuthContext.Provider value={{ user, role, userPermissions, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
